<div
  class="canvas-component flex-row"
  [class.crosshair]="cs.shapeAddMode"
  (click)="clickCanvas()"
  #canvasComponent
>
  <div class="recording-overlay" *ngIf="isExportInProgress$ | async">
    <div class="flex-column center gap-20">
      <div class="fs-14">Video is being exported...</div>
      <div class="progress-bar">
        <div class="frame"></div>
        <div
          *ngIf="(relativeAnimationTime$ | async) > 0"
          class="fill"
          [style.width.px]="(relativeAnimationTime$ | async) * 240"
        ></div>
      </div>
      <div class="cancel">Cancel</div>
    </div>
  </div>

  <div class="base-overlay" *ngIf="overlay$ | async">
    <ng-container [ngSwitch]="overlay$ | async">
      <div *ngSwitchCase="'image-selector'">Image Selector</div>
      <image-prompt-panel *ngSwitchCase="'image-prompt'"></image-prompt-panel>
      <!-- 
        <div
          *ngSwitchCase="'image-prompt'"
          class="image-prompt"
          (click)="$event.stopPropagation()"
        >
          <textarea
            placeholder="Enter image prompt"
            (keyup)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          ></textarea>
          <div class="flex-row justfity-end row">
            <div class="arrow-border">
              <nw-icon type="arrow_upward"></nw-icon>
            </div>
          </div>
        </div>
      -->
    </ng-container>
  </div>

  <div class="flex-row flex-fill">
    <div class="flex-column fill-available-height flex-1-1-auto">
      <div class="flex-row flex-fill gap-8">
        <!-- Canvas -->
        <div
          class="flex-1-1-auto viewer-portrait"
          [ngClass]="{
            'viewer-landscape': !cs.isPortrait,
            'viewer-portrait': cs.isPortrait,
          }"
          style="position: relative; background: transparent"
          (mouseenter)="onCanvasMouseEnter()"
          (contextmenu)="onRightClick($event)"
          appDnd
          (fileDropped)="onFileDropped($event)"
          #canvasContainer
        >
          <!-- <nw-canvas-control-panel></nw-canvas-control-panel> -->
          <nw-spacing-controller
            *ngIf="
              shapeService.selectionAlignType && serviceDragState == 'idle'
            "
          ></nw-spacing-controller>

          <nw-comment-thread
            *ngIf="commentToShow$ | async as commentToShow"
            [config]="commentToShow"
          ></nw-comment-thread>

          <!-- Scene controls (add before, delete, add after) for current scene -->
          <ng-container
            *ngIf="cs.studioMode && (currentSceneOverlay$ | async) as overlay"
          >
            <div
              class="above-scene-container"
              [style.left.px]="aboveCanvasX"
              [style.top.px]="aboveCanvasY"
              [style.width.px]="aboveCanvasWidth"
              [style.height.px]="aboveCanvasHeight"
              *ngIf="
                (isPanelStable$ | async) &&
                (currentSceneIndex$ | async) < overlay.totalScenes - 1
              "
            >
              <span class="scene-index-label"
                >{{ (currentSceneIndex$ | async) + 1 }} /
                {{ overlay.totalScenes - 1 }}</span
              >
              <!-- Font Family Selector -->
              <div
                class="text-style-edits"
                *ngIf="selectedShape$ | async as selectedShape"
                (click)="$event.stopPropagation()"
              >
                <div
                  class="color-picker-container"
                  (click)="$event.stopPropagation()"
                >
                  <div
                    class="color-sample"
                    [style.background-color]="
                      selectedShape.descriptor.fill || '#ccc'
                    "
                    [colorPicker]="selectedCellColor"
                    (colorPickerChange)="onColorSelected($event)"
                    [cpAlphaChannel]="'disabled'"
                    [cpSaveClickOutside]="true"
                    [cpCloseClickOutside]="true"
                    cpPosition="bottom"
                    cpPositionOffset="-120%"
                    title="Text color"
                  ></div>
                </div>
                <nw-font-family-selector
                  [fontFamily]="selectedShape.descriptor.fontFamily || 'Inter'"
                  [emitOnly]="true"
                  (fontSelected)="onFontFamilySelected($event)"
                ></nw-font-family-selector>

                <!-- Text Alignment Toggle -->
                <button
                  class="align-toggle-btn"
                  (click)="toggleTextAlign(selectedShape.descriptor.align)"
                  title="Text alignment: {{
                    selectedShape.descriptor.align || 'center'
                  }}"
                >
                  <nw-icon
                    *ngIf="selectedShape.descriptor.align === 'left'"
                    type="format_align_left"
                    [size]="16"
                    color="#666"
                  ></nw-icon>
                  <nw-icon
                    *ngIf="
                      !selectedShape.descriptor.align ||
                      selectedShape.descriptor.align === 'center'
                    "
                    type="format_align_center"
                    [size]="16"
                    color="#666"
                  ></nw-icon>
                  <nw-icon
                    *ngIf="selectedShape.descriptor.align === 'right'"
                    type="format_align_right"
                    [size]="16"
                    color="#666"
                  ></nw-icon>
                </button>

                <!-- Color Picker -->

                <button
                  class="font-selector-close-btn"
                  (click)="closeFontSelector()"
                  title="Close"
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              <!-- <div></div> -->
            </div>

            <div
              class="add-scene-button-container add-before"
              *ngIf="cs.panelStable"
              [class.portrait-mode]="isPortraitMode$ | async"
              [style.top.px]="addBeforeY"
              [style.left.px]="addBeforeX"
              [style.width.px]="addBeforeWidth"
              [style.height.px]="addBeforeHeight"
              (click)="studioService.addSceneBefore(); $event.stopPropagation()"
              [ngClass]="{ 'add-before-first': cs.isFirstScene }"
            >
              <div class="add-scene-button" title="Add scene before">
                <nw-icon type="add" [size]="12" color="black"></nw-icon>
              </div>
            </div>

            <!-- Add scene after button -->
            <div
              class="add-scene-button-container add-after"
              *ngIf="cs.panelStable"
              [class.portrait-mode]="isPortraitMode$ | async"
              [ngClass]="{ 'add-after-last': cs.isLastScene }"
              [style.top.px]="addAfterY"
              [style.left.px]="addAfterX"
              [style.width.px]="addAfterWidth"
              [style.height.px]="addAfterHeight"
              (click)="studioService.addSceneAfter(); $event.stopPropagation()"
            >
              <div class="add-scene-button" title="Add scene after">
                <nw-icon type="add" [size]="12" color="black"></nw-icon>
              </div>
            </div>

            <!-- Delete scene button -->
            <div
              class="scene-overlay"
              *ngIf="cs.panelStable"
              [style.top.px]="cs.rootContainer?.position?.y"
              (click)="
                studioService.deleteScene(overlay.sceneId);
                $event.stopPropagation()
              "
            >
              <div class="scene-delete-button" title="Delete scene">
                <nw-icon type="close" [size]="12" color="black"></nw-icon>
              </div>
            </div>

            <!-- Image Edit Panel -->
            <!-- <div
              class="image-edit-panel"
              *ngIf="selectedImageCell && cs.panelStable"
              [style.top.px]="imageEditPanelY"
              [style.left.px]="imageEditPanelX"
              [style.width.px]="imageEditPanelWidth"
              [style.height.px]="imageEditPanelHeight"
            >
              <div class="image-edit-panel-content">
                <button
                  class="image-edit-button"
                  title="Fit image"
                  (click)="setImageFit()"
                >
                  <nw-icon
                    type="fit_screen"
                    [size]="11"
                    [outlined]="true"
                  ></nw-icon>
                  <span>Fit</span>
                </button>
                <button
                  class="image-edit-button"
                  title="Cover image"
                  (click)="setImageCover()"
                >
                  <nw-icon
                    type="crop_free"
                    [size]="11"
                    [outlined]="true"
                  ></nw-icon>
                  <span>Cover</span>
                </button>
              </div>
            </div> -->
          </ng-container>

          <!-- <div
            *ngIf="cs.showFitCanvas"
            class="flex-row gap-8 fs-12 pointer"
            style="
              position: absolute;
              z-index: 1;
              bottom: 4px;
              left: 50%;
              transform: translate(-50%, -50%);
              border: 1px solid white;
              padding: 6px;
              border-radius: 4px;
            "
            (click)="cs.fitCanvas()"
          >
            <div style="color: white">Fit slide</div>
            <nw-icon
              type="fit_screen"
              [size]="18"
              [outlined]="true"
              color="white"
            ></nw-icon>
          </div> -->
          <!-- <ng-container *ngIf="cs.previewShape">
            <div
              *ngIf="bgSelectorPosition$ | async as bgSelectorPosition"
              style="
                width: 14px;
                height: 14px;
                border: 1.25px solid white;
                border-radius: 3px;
                position: relative;
                z-index: 99;
              "
              [style.background]="canvasBackgroundColor$ | async"
              [style.left.px]="
                bgSelectorPosition?.x +
                cs._screenX * bgSelectorPosition?.scale -
                22
              "
              (click)="openCanvasBgColorEdit()"
              [style.top.px]="bgSelectorPosition?.y - 22"
            ></div>
          </ng-container> -->

          <!-- <nw-container-panel></nw-container-panel> -->
          <div
            fxFlex="1 1 auto"
            [style.visibility]="
              (isPreviewShapeLoading$ | async) ? 'hidden' : 'visible'
            "
            #canvas
            id="_canvas"
            (click)="click2()"
          ></div>

          <div *ngIf="isPreviewShapeLoading$ | async" class="file-is-loading">
            <div class="fs-14 blink">File is being loaded</div>
          </div>
        </div>
        <!-- <nw-animation-panel
      *ngIf="
      !shapeService.previewShapeIsLoading && !(isStoryBoardOpened$ | async)
      "
    ></nw-animation-panel> -->
        <!-- *ngIf="!(isPreviewShapeLoading$ | async)" -->
      </div>

      <!-- dirty hack -->
      <!-- <div style="height: 114px">
        <nw-slide-viewer
          *ngIf="!(isPreviewShapeLoading$ | async)"
        ></nw-slide-viewer>
      </div> -->
    </div>
    <!-- <nw-shape-attribute-panel></nw-shape-attribute-panel> -->
  </div>
  <!-- 
  <div class="fill-available-height flex-column" style="position: relative">
    <nw-zoom-panel></nw-zoom-panel>
    <nw-shape-attribute-panel fxFlex="1 1 auto"></nw-shape-attribute-panel>
  </div> 
  -->

  <!-- <div>
    <nw-stroke-panel></nw-stroke-panel>
  </div> -->

  <ng-container *ngIf="!recordMode">
    <nw-component-search
      *ngIf="showComponentSearch$ | async"
    ></nw-component-search>
    <nw-image-processing-panel></nw-image-processing-panel>
  </ng-container>

  <ng-container *ngIf="!recordMode">
    <nw-general-selector *ngIf="cs.generalSelectorConfig"></nw-general-selector>
  </ng-container>
</div>
